// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".separator-white[data-v-77fadf6f]{color:#fff;position:relative;width:100%;height:5rem}@media(min-width:768px){.separator-white[data-v-77fadf6f]{height:7rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
